export default "__VITE_ASSET__00261efb__"